<template lang="pug">
v-dialog(v-model="show", persistent, max-width="50%")
    v-card(v-if="fatura")
        v-card-title
            v-flex.md8.title Cálculo da Comissão
            v-flex.md4.text-xs-right
              v-btn(flat, @click="close()", density="comfortable", icon="", variant="plain")
                v-icon close
        v-card-text
            template
                h4.pt-3(style="font-size: 18px; color:#1113128A; font-weight:500") Cálculo do total bruto
                div(style="background-color:#FAFAFA; border-radius:8px").pa-3.mt-4.mb-4
                    v-layout(row, wrap).pb-4
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                            label <strong>  {{(fatura.indicadores ? fatura.indicadores.quantidadePedidos : 0)}} vendas </strong> confirmadas
                            br
                            small(style="font-size:16px; color:#1113128A" v-if="fatura.indicadores && fatura.comissao_subsidio && !fatura.indicadores.quantidadeTaxaServico")
                              | (incluindo: {{fatura.indicadores.quantidadeDescontos}} cupons + {{fatura.indicadores.quantidadeReembolsosPromocionais}} subsídios)
                            small(style="font-size:16px; color:#1113128A" v-if="fatura.indicadores && fatura.comissao_subsidio && fatura.indicadores.quantidadeTaxaServico")
                              | (incluindo: {{fatura.indicadores.quantidadeDescontos}} cupons + {{fatura.indicadores.quantidadeReembolsosPromocionais}} subsídios + {{fatura.indicadores.quantidadeTaxaServico}} taxas de serviço)
                            small(style="font-size:16px; color:#1113128A" v-if="!fatura.comissao_subsidio")
                              | (incluindo: {{fatura.indicadores.quantidadeDescontos}} cupons)
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                            strong + {{ (fatura.indicadores ? (fatura.indicadores.totalVendas + fatura.indicadores.totalTaxaServico) : 0) | currency }}
                    v-layout(row, wrap, v-if="fatura.indicadores && fatura.indicadores.quantidadePedidosExpirados").pb-4
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                            label <strong>  {{(fatura.indicadores ? fatura.indicadores.quantidadePedidosExpirados : 0)}} vendas </strong> canceladas por tempo
                            br
                            small(style="font-size:16px; color:#1113128A" v-if="fatura.indicadores && fatura.comissao_subsidio && !fatura.indicadores.quantidadeTaxaServicoPedidosExpirados")
                              | (incluindo: {{fatura.indicadores.quantidadeDescontosPedidosExpirados}} cupons + {{fatura.indicadores.quantidadeReembolsosPromocionaisPedidosExpirados}} subsídios)
                            small(style="font-size:16px; color:#1113128A" v-if="fatura.indicadores && fatura.comissao_subsidio && fatura.indicadores.quantidadeTaxaServicoPedidosExpirados")
                              | (incluindo: {{fatura.indicadores.quantidadeDescontosPedidosExpirados}} cupons + {{fatura.indicadores.quantidadeReembolsosPromocionaisPedidosExpirados}} subsídios + {{fatura.indicadores.quantidadeTaxaServicoPedidosExpirados}} taxas de serviço)
                            small(style="font-size:16px; color:#1113128A" v-if="!fatura.comissao_subsidio")
                              | (incluindo: {{fatura.indicadores.quantidadeDescontosPedidosExpirados}} cupons)
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                            strong + {{ (fatura.indicadores ? (fatura.indicadores.totalPedidosExpirados + fatura.indicadores.totalTaxaServicoPedidosExpirados) : 0) | currency }}

                div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="fatura.indicadores.quantidadeTaxaServico || fatura.indicadores.quantidadeTaxaServicoPedidosExpirados").pt-3.pb-3.mb-3.mt-3.pl-3
                    v-layout(row,wrap)
                      v-flex.md8.xs12(style="font-size:18px; color:#000")
                        strong Total bruto de {{(fatura.indicadores.quantidadePedidos + fatura.indicadores.quantidadePedidosExpirados)}} vendas
                        <br>
                        small(style="font-size:16px; color:#1113128A" v-if="!fatura.indicadores.quantidadePedidosExpirados") ({{fatura.indicadores.quantidadePedidos}} confirmadas)
                        small(style="font-size:16px; color:#1113128A" v-if="fatura.indicadores.quantidadePedidosExpirados") ({{fatura.indicadores.quantidadePedidos}} confirmadas + {{fatura.indicadores.quantidadePedidosExpirados}} canceladas por tempo)
                      v-flex.md4.xs12.text-md-right.pr-3(style="font-size:18px; color:#111312CC")
                        strong {{ (fatura.indicadores.totalVendas + fatura.indicadores.totalTaxaServico + fatura.indicadores.totalPedidosExpirados + fatura.indicadores.totalTaxaServicoPedidosExpirados) | currency }}

                div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="fatura.indicadores.quantidadeTaxaServico").pt-3.pb-3.mb-3.mt-3.pl-3
                    v-layout(row,wrap)
                      v-flex.md8.xs12(style="font-size:18px; color:#000")
                        label <strong>Taxa de serviço de {{(fatura.indicadores ? fatura.indicadores.quantidadeTaxaServico : 0)}} vendas confirmadas </strong>
                      v-flex.md4.xs12.text-md-right.pr-3(style="font-size:18px; color:#111312CC")
                        strong - {{ (fatura.indicadores ? fatura.indicadores.totalTaxaServico : 0) | currency }}

                div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="fatura.indicadores.quantidadeTaxaServicoPedidosExpirados && fatura.indicadores.quantidadePedidosExpirados").pt-3.pb-3.mb-3.mt-3.pl-3
                    v-layout(row,wrap)
                      v-flex.md8.xs12(style="font-size:18px; color:#000")
                        label <strong>Taxa de serviço de {{(fatura.indicadores ? fatura.indicadores.quantidadeTaxaServicoPedidosExpirados : 0)}} vendas canceladas por tempo </strong>
                      v-flex.md4.xs12.text-md-right.pr-3(style="font-size:18px; color:#111312CC")
                        strong - {{ (fatura.indicadores ? fatura.indicadores.totalTaxaServicoPedidosExpirados : 0) | currency }}

                div(style="border:1px solid; border-radius:8px; color:#0000000A").pa-3.mt-4.mb-4
                    v-layout(row, wrap)
                        v-flex.md8.xs12(style="font-size:18px; color:#111312")
                            strong Base de cálculo da comissão
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong {{ (fatura.indicadores ? (fatura.indicadores.totalVendas + fatura.indicadores.totalPedidosExpirados) : 0) | currency }}

                div(style="border:1px solid; border-radius:8px; color:#0000000A").pa-3.mt-4.mb-4
                    v-layout(row,wrap)
                        v-flex.md8.xs12(style="font-size:18px; color:#111312")
                            strong Comissão
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                            strong {{(fatura.indicadores ? fatura.indicadores.totalComissao : 0) | currency}}

        v-card-actions.mr-4.pb-3
            v-spacer
            v-btn(flat,@click="close()") Fechar

</template>

<script>

export default {
  props: {
  },
  data () {
    return {
        show : false,
        fatura : null,
    }
  },
  created () {

  },
  watch: {
  },
  computed: {
  },
  methods: {
    open(fatura){
        const vm = this;
        vm.fatura = fatura;
        vm.show = true;
    },
    close(){
        const vm = this;
        vm.fatura = null;
        vm.show = false;
    }
  }
}
</script>
